import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';

const mutation = gql`
mutation signIn($authId: String!){
  authSignIn(authId: $authId) {
    token
    customer {
      id
      identified
      firstName
      lastName
      description
      accounts {
        id
        provider
        providerId
      }
    }
  }
}`;

function parseAccount(item) {
  return {
    id: item.id,
    title: item.providerId,
    type: item.provider,
  };
}

function parseCustomer(item) {
  return {
    id: item.id,
    title: item.firstName,
    firstName: item.firstName,
    lastName: item.lastName,
    description: item.description,
    identified: !!item.identified,
    accounts: (item.accounts && item.accounts.map((res) => parseAccount(res))) || [],
  };
}

function authSignIn(authId) {
  return apollo.client.mutate({
    variables: {
      authId,
    },
    mutation,
  }).then((res) => ({
    token: res.data.authSignIn.token,
    customer: parseCustomer(res.data.authSignIn.customer),
  }));
}

export default authSignIn;
